import React from 'react'

let MenuContext = React.createContext({
  acoes: [],
})

export default MenuContext
